class FeaturedNavigation extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    if (this.dataset.mode === 'mobile') {
      const details = this.closest('details');
      const summary = details?.querySelector(':scope > summary');
      const root = this.closest('header-drawer')?.querySelector(':scope > details') ?? details;
      const onToggle = () => {
        if (details?.open && root?.open) this.#loadImages();
      };
      summary?.addEventListener('click', this.#loadImages, options);
      details?.addEventListener('toggle', onToggle, options);
      if (root !== details) root?.addEventListener('toggle', onToggle, options);
      if (details?.open && root?.open) this.#loadImages();
    } else {
      const item = this.closest('.menu-list__list-item');
      const trigger = item?.querySelector(':scope > .menu-list__link');
      item?.addEventListener('pointerenter', this.#loadImages, options);
      item?.addEventListener('focusin', this.#loadImages, options);
      trigger?.addEventListener('click', this.#loadImages, options);
      if (trigger?.getAttribute('aria-expanded') === 'true') this.#loadImages();
    }
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #loadImages = () => {
    for (const image of this.querySelectorAll('img[data-src]')) {
      image.srcset = image.dataset.srcset ?? '';
      image.src = image.dataset.src;
      delete image.dataset.srcset;
      delete image.dataset.src;
    }
  };
}

if (!customElements.get('jp-featured-navigation')) {
  customElements.define('jp-featured-navigation', FeaturedNavigation);
}
